import React from 'react';
import { Calendar, MapPin, ExternalLink } from 'lucide-react';

function EventCard({ theme, event, geo }) {
  const eventUrl = geo ? `/${geo.state}/${geo.metro}/craft-fairs#${event.id}` : `#${event.id}`;
  return (
    <div style={{
      backgroundColor: theme.colors.surface, borderRadius: theme.borderRadius.md,
      padding: '25px', border: `2px solid ${theme.colors.primary}`
    }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
        <div>
          <h3 style={{ fontFamily: theme.fonts.heading, color: theme.colors.heading, margin: '0 0 10px 0', fontSize: '1.3rem' }}>
            {event.name}
          </h3>
          <div style={{ color: theme.colors.primary, fontWeight: '600', margin: '5px 0', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Calendar size={18} />
            {new Date(event.date).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
          </div>
          <div style={{ color: theme.colors.text, margin: '5px 0', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <MapPin size={18} />
            {event.location.city}, {event.location.state}
          </div>
          <p style={{ color: theme.colors.text, margin: '15px 0 0 0', lineHeight: '1.6' }}>
            {event.time} • {event.location.venue}
          </p>
          {event.vendorInfo?.boothNumber && (
            <p style={{ color: theme.colors.primary, margin: '10px 0 0 0', fontWeight: '600' }}>
              Booth: {event.vendorInfo.boothNumber}
            </p>
          )}
          <a href={eventUrl} style={{
            display: 'inline-flex', alignItems: 'center', gap: '6px',
            color: theme.colors.primary, textDecoration: 'none',
            fontWeight: '600', marginTop: '10px', fontSize: '0.95rem'
          }}>
            View Event Details <ExternalLink size={14} />
          </a>
          {event.details?.website && (
            <a
              href={event.details.website.startsWith('http') ? event.details.website : `https://${event.details.website}`}
              target="_blank" rel="noopener noreferrer"
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '6px',
                color: theme.colors.primary, textDecoration: 'none',
                fontWeight: '600', marginTop: '8px', fontSize: '0.95rem'
              }}
            >
              Visit Event Website <ExternalLink size={14} />
            </a>
          )}
        </div>
        <div style={{
          borderRadius: theme.borderRadius.sm, overflow: 'hidden',
          height: '100%', minHeight: '250px', border: `2px solid ${theme.colors.border}`
        }}>
          <iframe
            title={`Map to ${event.name}`}
            width="100%" height="100%"
            frameBorder="0" style={{ border: 0 }}
            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDqgiub0NYn_aqdIn-T3MBJ2PedEZCKsbo&q=${encodeURIComponent(event.location.address)}`}
            allowFullScreen
          />
        </div>
      </div>
      {event.vendorInfo?.note && (
        <p style={{
          color: '#6B7280', margin: '0', lineHeight: '1.6', padding: '15px',
          backgroundColor: '#FEF3C7', borderRadius: theme.borderRadius.sm,
          borderLeft: '4px solid #F59E0B'
        }}>
          {event.vendorInfo.note}
        </p>
      )}
    </div>
  );
}

export const NextEvent = ({ theme, events, geo }) => {
  if (!events.length || !events[0]) return null;
  return (
    <section style={{
      backgroundColor: theme.colors.background, borderRadius: theme.borderRadius.lg,
      boxShadow: theme.shadows.md, padding: '40px', marginBottom: '40px'
    }}>
      <h2 style={{ fontFamily: theme.fonts.heading, color: theme.colors.heading, fontSize: '2rem', margin: '0 0 30px 0', textAlign: 'center' }}>
        Our Next Event
      </h2>
      <EventCard theme={theme} event={events[0]} geo={geo} />
    </section>
  );
};

export const EventsList = ({ theme, events, geo }) => {
  if (!events.length) return null;
  return (
    <section style={{
      backgroundColor: theme.colors.background, borderRadius: theme.borderRadius.lg,
      boxShadow: theme.shadows.md, padding: '40px', marginBottom: '40px'
    }}>
      <h2 style={{ fontFamily: theme.fonts.heading, color: theme.colors.heading, fontSize: '2rem', margin: '0 0 30px 0', textAlign: 'center' }}>
        Our Upcoming Events
      </h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '25px', marginBottom: '40px' }}>
        {events.map((event, index) => (
          <EventCard key={index} theme={theme} event={event} geo={geo} />
        ))}
      </div>
    </section>
  );
};
